/* tslint:disable */
/* eslint-disable */
/**
 * Easy Invoices API v1
 * The Easy Invoices API for Shopify embedded app - automatic invoice generation and export functionality
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * `EXPIRED` is historical only: nothing writes it any more, but rows from the 14-day era still carry it.
 * @export
 * @enum {string}
 */

export enum OpsDatevInviteStatus {
    Pending = 'PENDING',
    Finalizing = 'FINALIZING',
    Finalized = 'FINALIZED',
    Expired = 'EXPIRED',
    Withdrawn = 'WITHDRAWN',
    Superseded = 'SUPERSEDED'
}



